import { render, staticRenderFns } from "./IconArrowBoth.vue?vue&type=template&id=87432458&"
import script from "./IconArrowBoth.vue?vue&type=script&lang=js&"
export * from "./IconArrowBoth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('87432458')) {
      api.createRecord('87432458', component.options)
    } else {
      api.reload('87432458', component.options)
    }
    module.hot.accept("./IconArrowBoth.vue?vue&type=template&id=87432458&", function () {
      api.rerender('87432458', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconArrowBoth.vue"
export default component.exports